import React from 'react';
import { Sparkles, ArrowRight, Check, Star } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const AestheticBeautyPage = () => {
  const { login } = useAuth();
  const features = ['Agendamento de procedimentos', 'Lembretes de retorno', 'Orçamentos automáticos', 'Fotos antes/depois'];
  const useCases = ['Clínicas estéticas', 'Harmonização facial', 'Dermatologia', 'Procedimentos corporais'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-rose-100 text-rose-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Sparkles className="h-4 w-4" />Estética
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                ChatAlfa para <span className="text-rose-500">Clínicas Estéticas</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">Automatize agendamentos de procedimentos estéticos e aumente a fidelização.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-rose-50 rounded-3xl p-8">
              <Star className="h-16 w-16 text-rose-500 mb-6" />
              <h3 className="font-bold text-xl mb-2">Clínicas Estéticas</h3>
              <p className="text-gray-600">+25% em procedimentos agendados</p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos para Estética</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Especialidades</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {useCases.map((uc) => (<Card key={uc} className="hover:shadow-lg transition-shadow"><CardContent className="p-6"><p className="font-medium text-gray-900">{uc}</p></CardContent></Card>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Transforme sua clínica estética</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default AestheticBeautyPage;
